var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"casePojectOverview"},[_c('div',{staticClass:"casePojectOverviewDiv"},[_c('p',{staticClass:"title"},[_vm._v("项目概况")]),_c('p',{staticClass:"textMsg",style:({width:this.width+'px', left:this.left+'px'}),attrs:{"id":"text"}},[_vm._v(_vm._s(_vm.pojectOverviewMsg))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }